import { Client } from 'urql';
import { propertyPageQuery } from './propertyPageQuery';

export const fetchPropertyPage = async ({
  client,
  slug,
  propertyId,
  toggleShowAVMData,
  toggleShowOriginNbnBrick,
  toggleMainImageDataMigration,
  togglePropertyReport,
  toggleBYBLegalDisclaimers,
  togglePcaChat,
  toggleGovernmentOverlaysUpdate,
  toggleAllianzRenewalBannerV2,
}: {
  client: Client;
  slug: string;
  propertyId: string;
  toggleShowAVMData: boolean;
  toggleShowOriginNbnBrick: boolean;
  toggleMainImageDataMigration: boolean;
  togglePropertyReport: boolean;
  toggleBYBLegalDisclaimers: boolean;
  togglePcaChat: boolean;
  toggleGovernmentOverlaysUpdate: boolean;
  toggleAllianzRenewalBannerV2: boolean;
}) => {
  const { data, error } = await client
    .query(propertyPageQuery, {
      slug,
      id: propertyId,
      toggleShowAVMData,
      toggleShowOriginNbnBrick,
      toggleMainImageDataMigration,
      togglePropertyReport,
      toggleBYBLegalDisclaimers,
      togglePcaChat,
      toggleGovernmentOverlaysUpdate,
      toggleAllianzRenewalBannerV2,
    })
    .toPromise();
  return { data, error };
};
